import type {I18nApi} from '@udemy/i18n';

import {LearningPathProgressState} from '../learning-path-status';

export type DescriptionResolver = (
    i18n: Pick<I18nApi, 'gettext' | 'interpolate'>,
    certificateTitle: string,
) => string;

/**
 * Maps each path progress state to the description shown above the cards.
 *
 * Defined at module level so the map is not re-created on every render.
 * Resolvers are lazy so only the selected message is built, and the `gettext`
 * literals stay at the call site to keep i18n extraction working.
 * NotEnrolled is intentionally absent: it falls back to the path's own description.
 */
export const PROGRESS_DESCRIPTIONS: Partial<
    Record<LearningPathProgressState, DescriptionResolver>
> = {
    [LearningPathProgressState.NotStarted]: ({gettext}) =>
        gettext('Let’s get started! Pass the graded quiz in each course to earn the certificate.'),
    [LearningPathProgressState.InProgress]: ({gettext}) =>
        gettext('You’re doing great! Pass the graded quiz in each course to earn the certificate.'),
    [LearningPathProgressState.Completed]: ({gettext, interpolate}, certificateTitle) =>
        interpolate(
            gettext('Congratulations! You earned the %(pathName)s certificate!'),
            {pathName: certificateTitle},
            true,
        ),
};
